const config = {
  apiBaseUrl: 'http://localhost:5000',
  socketUrl: 'http://localhost:5000'
};

config.serverBaseUrl = config.apiBaseUrl;

export default config;
